import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'replaceunderscore',
  standalone: false,
})
export class ReplaceunderscorePipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/_/g, ' ')
  }
}
